import { ISupportType, queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams } from '../../shared/hooks/new-read-only.hook';
import { supportTypeClient } from '../clients/support-type.client';

const client = supportTypeClient;
const listKey = queryKeys.SUPPORT_TYPES;
const itemKey = queryKeys.SUPPORT_TYPE;

export function useSupportType(...args: UseItemParams<ISupportType>) {
    return useItem(client, itemKey, args);
}

export function useSaveSupportType() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteSupportType() {
    return useDelete(client, listKey);
}
